import { createSelector } from 'reselect';
import { AppState } from '../createStore';
import { isCoupon } from '@wix/restaurants-client-logic';

export const hasCouponsSelector = createSelector(
  (state: AppState) => state.session.menu.chargesV2,
  (charges) => {
    return charges?.some(isCoupon);
  },
);
